import { ActionTypes } from "../constants/index";

export default function sidechains(
	state = {
		isFetching: false,
	},
	action = ""
) {
	const ssc = state.selectedSidechain || {};

	switch (action.type) {
		case ActionTypes.UPDATE_SIDECHAIN:
			return Object.assign({}, state, {
				selectedSidechain: action.sidechain,
				sidechains: state.sidechains.map((item) => {
					return item.id === action.sidechain.id ? action.sidechain : item;
				}),
			});

		case ActionTypes.SET_SIDECHAIN:
			return Object.assign({}, state, {
				selectedSidechain: action.sidechain,
			});

		case ActionTypes.FETCH_SIDECHAINS_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
			});

		case ActionTypes.FETCH_SIDECHAINS_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				sidechains: action.sidechains,
				selectedSidechain: action.sidechains[0],
			});

		case ActionTypes.FETCH_SIDECHAINS_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: "Something wrong happened. Please come back later",
			});

		case ActionTypes.CREATE_SIDECHAIN_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: "Error while creating node",
			});

		case ActionTypes.ADD_SIDECHAIN_TO_LIST:
			return Object.assign({}, state, {
				isFetching: false,
				sidechains: [...(state.sidechains || []), action.sidechain],
				selectedSidechain: action.sidechain,
			});

		case ActionTypes.JOIN_SIDECHAIN_SUCCESS:
			const allSidechains = state.sidechains || [];
			const idx = allSidechains.findIndex(
				(e) => e.publicKey === action.sidechain.publicKey
			);
			if (idx >= 0) {
				allSidechains[idx] = action.sidechain;
			} else {
				allSidechains.push(action.sidechain);
			}

			localStorage.setItem("sidechains", JSON.stringify(allSidechains));

			return Object.assign({}, state, {
				isFetching: false,
				sidechains: allSidechains,
				selectedSidechain: action.sidechain
			});

		// TASKS
		case ActionTypes.UPDATE_TASK_SUCCCESS:
			const compute_tasks = ssc.compute_tasks.map((item) => {
				return item.id === action.task.id ? action.task : item;
			});

			return Object.assign({}, state, {
				isFetching: false,
				message: "Task updated successfully",
				selectedSidechain: {
					...ssc,
					compute_tasks,
				},
			});

		case ActionTypes.CREATE_TASK_SUCCCESS:
			const tasks = [...(ssc.compute_tasks || []), action.task];

			return Object.assign({}, state, {
				isFetching: false,
				message: "Task updated successfully",
				selectedSidechain: {
					...ssc,
					compute_tasks: tasks,
				},
			});

		// ORACLES
		case ActionTypes.UPDATE_ORACLE_SUCCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				message: "Oracle updated successfully",
				selectedSidechain: {
					...ssc,
					oracles: (ssc.oracles || []).map((item) => {
						return item.id === action.oracle.id ? action.oracle : item;
					}),
				},
			});

		case ActionTypes.CREATE_ORACLE_SUCCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				message: "Role created successfully",
				selectedSidechain: {
					...ssc,
					oracles: [...(ssc.oracles || []), action.oracle],
				},
			});

		// ROLES
		case ActionTypes.UPDATE_ROLE_SUCCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				message: "Role updated successfully",
				selectedSidechain: {
					...ssc,
					roles: ssc.roles.map((item) => {
						return item.id === action.role.id ? action.role : item;
					}),
				},
			});

		case ActionTypes.CREATE_ROLE_SUCCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				message: "Role created successfully",
				selectedSidechain: {
					...ssc,
					roles: [...(ssc.roles || []), action.role],
				},
			});

		case ActionTypes.DELETE_ROLES:
			return Object.assign({}, state, {
				isFetching: false,
				message: "Role removed successfully",
				selectedSidechain: {
					...ssc,
					roles: ssc.roles?.filter((r) => !action.roleIds.includes(r.id)),
				},
			});

		// USER
		case ActionTypes.UPDATE_USER_DETAILS:
			const newSidechain = {
				...ssc,
				user: action.user,
			};

			return Object.assign({}, state, {
				isFetching: false,
				message: "User updated successfully",
				selectedSidechain: newSidechain,
				sidechains: state.sidechains.map((item) => {
					return item.id === newSidechain.id ? newSidechain : item;
				}),
			});

		// SCOPES
		case ActionTypes.UPDATE_SCOPE_SUCCCESS:
			const updatedSidechain = {
				...ssc,
				scopes: ssc.scopes.map((item) => {
					return item.id === action.scope?.id ? action.scope : item;
				}),
			};
			return Object.assign({}, state, {
				isFetching: false,
				message: "Scope updated successfully",
				selectedSidechain: updatedSidechain,
				sidechains: state.sidechains.map((item) => {
					return item.id === updatedSidechain.id ? updatedSidechain : item;
				}),
			});

		case ActionTypes.CREATE_SCOPE_SUCCCESS:
			const new_ssc = {
				...ssc,
				scopes: [...(ssc.scopes || []), action.scope],
			};

			return Object.assign({}, state, {
				isFetching: false,
				message: "Scope created successfully",
				selectedSidechain: new_ssc,
				sidechains: state.sidechains.map((item) => {
					return item.id === new_ssc.id ? new_ssc : item;
				}),
			});

		// NODES
		case ActionTypes.UPDATE_NODE:
			const nodeSidechain = {
				...ssc,
				nodes: ssc.nodes.map((item) => {
					return item.id === action.node.id ? action.node : item;
				}),
			};
			return Object.assign({}, state, {
				isFetching: false,
				message: "Node updated successfully",
				selectedSidechain: nodeSidechain,
				sidechains: state.sidechains.map((item) => {
					return item.id === nodeSidechain.id ? nodeSidechain : item;
				}),
			});

		case ActionTypes.CREATE_NODE_SUCCCESS:
			const newNodeSidechain = {
				...ssc,
				nodes: [...(ssc.nodes || []), action.node],
			};

			return Object.assign({}, state, {
				isFetching: false,
				message: "Node created successfully",
				selectedSidechain: newNodeSidechain,
				sidechains: state.sidechains.map((item) => {
					return item.id === newNodeSidechain.id ? newNodeSidechain : item;
				}),
			});
		
		// USER ACCOUNTS
		case ActionTypes.CREATE_ACCOUNT_SUCCESS:
			const newAccountsSideChain = {
				...ssc,
				permissions: action.permissions
			};
			return Object.assign({}, state, {
				isFetching: false,
				message: "Account(s) created successfully",
				selectedSidechain: newAccountsSideChain,
				sidechains: state.sidechains.map((item) => {
					return item.id === newAccountsSideChain.id ? newAccountsSideChain : item;
				}),
			});

		default:
			return state;
	}
}
